import store from '@/store/index.js'
let dic = store.state.dic;

import { validateNumber } from "@/libs/elementChecker.js";


export default function Configs(that) {

   const jxfFormItems = [
        {
            label: "姓名",
            span: 12,
            model: "studentName",
            disabled: true,
        },
        {
            label: "身份证号",
            span: 12,
            model: "idCard",
            disabled: true,
        },
        {
            label: "身高",
            span: 12,
            model: "height",
            placeholder: '示例：170，即代表1米70',
        },
        {
            label: "体重",
            span: 12,
            model: "weight",
            placeholder: '示例：50，即代表体重50kg',
        },
        {
            label: "尺码",
            span: 12,
            model: "dressSize",
            type: 'select',
            placeholder: '请选择尺码',
            options: dic._SIZES
        },
        {
            label: "鞋码",
            span: 12,
            model: "shoeSize",
            placeholder: '示例：40，即代表鞋码40码',
        },
        {
            label: "备注",
            span: 24,
            model: "remark",
            type: 'textarea',
            placeholder: '请填写备注',
        },
    ]
    const jxfFormRules = {
        'height': [{
            required: true,
            // message: "请输入身高",
            validator: validateNumber,
            trigger: "blur"
        }],
        'weight': [{
            required: true,
            // message: "请输入体重",
            validator: validateNumber,
            trigger: "blur"
        }],
        'dressSize': [{
            required: true,
            message: "请选择尺码",
            trigger: "blur"
        }],
        'shoeSize': [{
            required: true,
            // message: "请输入鞋码",
            validator: validateNumber,
            trigger: "blur"
        }],
    }
    return {
        jxfFormItems,
        jxfFormRules
    }
}
